var map = {
	"./Arjuna.jpg": 680,
	"./Bhima.jpg": 336,
	"./Durga.jpg": 97,
	"./Eklavya.jpg": 199,
	"./Ghatotkacha.jpg": 30,
	"./Hanuman.jpg": 99,
	"./Karna.jpg": 643,
	"./Krishna.jpg": 634,
	"./Rama.jpg": 930,
	"./Shiva.jpg": 585,
	"./Vamana.jpg": 705,
	"./Yudhishtira.jpg": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 261;